import React, { useMemo } from 'react';
import c from 'classnames';
import i18next from 'i18next';
import Immutable from 'immutable';
import Sticky from 'react-stickynode';

import { Paragraph, View } from '@uncinc/react-drupal-core';

import {
  Accordion,
  AccordionItem,
  Container,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import { AccordionMenu, Breadcrumbs, WysiwygField } from '../../../../components';

import './style.scss';

const NodeCaoPage = ({ entity, className }) => {
  const classNames = c('NodeCao', 'NodeCao--Page', className);
  const node = entity.toJS();

  const title = node.title[0].value;
  const body = node.body[0]?.processed;
  const imageUrl = node.field_media[0]?.styles.crop_2_1;
  const chapters = node.field_paragraphs;

  const tableOfContents = useMemo(() => {
    if (chapters.length === 0) {
      return;
    }

    function mapSection(section) {
      const targetId = section.target_id;
      const language = section.entity.langcode[0].value;

      return {
        id: `paragraph:${targetId}:${language}`,
        number: section.entity.field_number[0].value,
        title: section.entity.field_title[0].value,
      };
    }

    function mapChapter(chapter, index) {
      const targetId = chapter.target_id;
      const language = chapter.entity.langcode[0].value;
      const sections = chapter.entity.field_section;

      return {
        id: `paragraph:${targetId}:${language}`,
        number: index + 1,
        title: chapter.entity.field_chapter_title[0].value,
        sections: sections.map(mapSection),
      };
    }

    return chapters.map(mapChapter);
  }, [chapters]);

  return (
    <article typeof="schema:WebPage" className={classNames}>
      <Container small>
        <div className="NodeCao--Page__inner">
          <Breadcrumbs includeCurrent />
          <div className="content-section">
            <div className="row">
              <div className="col-12">
                <div className="NodeCao--Page__hero">
                  <h1>{title}</h1>
                  {body && (
                    <WysiwygField
                      className="body-bold"
                      property="schema:text"
                      html={body}
                    />
                  )}
                  <Accordion className="NodeCao--Page__hero__pdf-download">
                    <AccordionItem
                      title={i18next.t('node.cao.download_pdf')}
                      iconClassName="icon-caret"
                      content={<View id="cao_pdf_links" display="overview" />}
                    />
                  </Accordion>
                  {imageUrl && (
                    <div className="NodeCao--Page__hero__image">
                      <Image src={imageUrl} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Sticky top={0}>
        <AccordionMenu items={tableOfContents} />
      </Sticky>
      <Container small>
        <div className="row">
          <div className="col-12">
            {chapters.length > 0 && (
              <div className="NodeCao--Page__chapters">
                {chapters.map((chapter, index) => {
                  const id = chapter.target_id;
                  const language = chapter.entity.langcode[0].value;

                  return (
                    <Paragraph
                      key={`paragraph:${id}:${language}`}
                      id={id}
                      index={index}
                      entity={Immutable.fromJS(chapter.entity)}
                    />
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </Container>
    </article >
  );
};

export default NodeCaoPage;
